<template>
  <div class="insert-answer">
    <el-checkbox v-model="content.checked" @change="handlerCheckbox"></el-checkbox>
    <div class="serial-label">
      <span class="text-medium leading-22 ml-1 mr-3 text-theme-black-650">插入题目答案</span>
    </div>
    <el-select v-model="value" size="small" class="bg-white-input mr-3" style="width:312px">
      <el-option class="fixed-width-select" v-for="o in options" :key="o.value" :value="o.value" :label="o.label" />
    </el-select>
  </div>
</template>

<script>
import { questionTypeEnum } from '@/components/survey-detail/config/config-wj.js'
export default {
  name: 'InsertAnswer',
  props: {
    content: Object
  },
  data() {
    return {
      value: '',
      canSerialTypes: [
        questionTypeEnum.SINGLE_CHOICE,
        questionTypeEnum.MULTIPLE_CHOICE,
        questionTypeEnum.SINGLE_SELECT,
        questionTypeEnum.MULTIPLE_SELECT,
        questionTypeEnum.SINGLE_TEXT_FILL,
        questionTypeEnum.MULTIPLE_TEXT_FILL
      ],
      QUESTION_GROUP_TYPE: 4 // 问题组的题目
    }
  },
  methods: {
    getValue() {
      return this.value
    },
    setValue(val) {
      this.value = val
    },
    handlerCheckbox(val) {
      if(!this.value) {
        return
      }
      if(val) {
        let item = this.options.find(o => o.value === this.value)
        this.$emit('format-change', `[Q${item.num}]`)
      } else {
        this.$emit('format-change', '')
      }
    },
    getNormalQuestions(list) {
      return list.filter(q => q.type !== this.QUESTION_GROUP_TYPE)
    }
  },
  computed: {
    showList() {
      return this.getNormalQuestions(this.$store.getters.questionList).filter(q => {
        return this.canSerialTypes.includes(q.question_type)
      })
    },
    options() {
      return this.showList.map(item => {
        return {
          num: item.num,
          label: `Q${item.num} ${item.content.text}`,
          value: item.id
        }
      })
    }
  },
  created() {
    if (this.content.defaultValue) {
      this.setValue(this.content.defaultValue)
    }
  },
  watch: {
    value(v) {
      let item = this.options.find(o => o.value === v)
      if(this.content.checked) {
        this.$emit('format-change', `[Q${item.num}]`)
      } else {
        this.$emit('format-change', '')
      }
      this.$emit('set-defaultValue', this.content.name, v)
    }
  }
}
</script>

<style scoped></style>
